import React from 'react'

import { ErrorMessage, useField } from 'formik'
import NumberFormat from 'react-number-format'

/**
 * @deprecated key-* components are no longer supported.
 */
export const KeyCurrencyField = (props) => {
  const { className, placeholderColor = 'key-grey', ...inputProps } = props

  const [field, , helpers] = useField(props)
  const base = `block min-w-[120px] max-w-[480px] overflow-truncate rounded text-[14px] h-[32px] px-3 text-gray-400 placeholder:text-${placeholderColor}`

  const normal = 'bg-white border border-gray-200'

  const focus = 'focus:border-gray-200 focus:ring-gray-400'

  const disabled = 'disabled:bg-gray-200 disabled:border-gray-200 disabled:text-gray-400'

  const readOnly =
    'read-only:bg-transparent read-only:border-transparent read-only:text-gray-400 read-only:focus:ring-transparent read-only:focus:border-transparent'

  const error = 'invalid:border-error invalid:focus:ring-transparent invalid:focus:border-error'

  const classes = [base, normal, focus, disabled, readOnly, error].join(' ')

  return (
    <div>
      <NumberFormat
        className={`input input-sm input-bordered w-full`}
        thousandSeparator
        prefix='$'
        value={field.value === null ? '' : field.value}
        onValueChange={(values) => {
          helpers.setValue(typeof values.floatValue === 'number' ? values.floatValue : null)
        }}
        {...inputProps}
      />
      <ErrorMessage name={props.name}>{(msg) => <p className='text-error'>{msg}</p>}</ErrorMessage>
    </div>
  )
}
